import { render, staticRenderFns } from "./buttons-icon.vue?vue&type=template&id=f5e034c8&scoped=true&"
import script from "./buttons-icon.vue?vue&type=script&lang=js&"
export * from "./buttons-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e034c8",
  null
  
)

export default component.exports